<template>
  <div>
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :disabled="acceptEditingDisabled"
          class="success mr-1"
          fab
          x-small
          v-on="{ ...tooltip }"
          @click="acceptEditing()"
        >
          <v-icon>mdi-account-search</v-icon>
        </v-btn>
      </template>
      <span>ACCEPT EDITING</span>
    </v-tooltip> -->

    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="success mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="acceptEditingDisabled"
            @click="acceptEditing()"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-account-search</v-icon>
              <span class="action-text">ACCEPT EDITING</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>ACCEPT EDITING</span>
    </v-tooltip>

    <!-- THE DIALOG BEGINS HERE -->
    <v-dialog persistent v-model="dialogAcceptEditing" max-width="750px">
      <v-card>
        <v-card-title class="justify-center text-h5 grey lighten-2">
          <span class="text-h5">ACCEPT EDITING</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-card width="100%" class="mt-3 mb-3 text-start">
                <v-card-title>I ACCEPT</v-card-title>
                <!-- <v-list subheader two-line flat dense>
                  <v-subheader class="text-h6">I agree:</v-subheader>

                  <v-list-item-group multiple>
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="primary"
                            v-model="checkboxAcceptEditing"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>Editing</v-list-item-title>
                          <v-list-item-subtitle
                            >I accept to edit the case.</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="primary"
                            v-model="checkboxAcceptEditing1"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>Documents</v-list-item-title>
                          <v-list-item-subtitle
                            >I will maintain document
                            privacy.</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list> -->
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    tile
                    dark
                    small
                    @click="closeAcceptEditingDialog"
                    class="mt-3 mr-2 error"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    tile
                    small
                    class="mt-3 success"
                    @click="compAcceptEditing"
                    >Submit</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "acceptEditing",
  props: [],
  components: {},

  data() {
    return {
      dialogAcceptEditing: false,
      // checkboxAcceptEditing: false,
      // checkboxAcceptEditing1: false,
    };
  },

  computed: {
    acceptEditingDisabled() {
      return !(
        this.caseState.casefile.fileStatus == `EDAC` &&
        this.caseState.casefile.editor == this.$store.state.auth.user.id
      );
    },

    ...mapState(["caseState"]),

    // isFileButtonDisabled() {
    //   return !(this.checkboxAcceptEditing && this.checkboxAcceptEditing1);
    // },
  },
  watch: {
    acceptEditing(val) {
      val || this.closeAcceptEditingDialog();
    },
  },

  methods: {
    // moment: function (date) {
    //   return moment(date);
    // },
    acceptEditing() {
      this.dialogAcceptEditing = true;
    },

    compAcceptEditing() {
      CasefileDataService.update(
        this.caseState.casefile.id,
        this.caseState.casefile,
        (this.caseState.casefile.fileStatus = `EDI`),
        (this.caseState.casefile.dateStartEdi = moment().format())
      )
        .then((response) => {
          this.closeAcceptEditingDialog();
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
        })
        .catch((e) => {
          console.log(e);
        });

      this.closeAcceptEditingDialog();
    },

    closeAcceptEditingDialog() {
      this.dialogAcceptEditing = false;
      this.$nextTick(() => {});
    },
  },
};
</script>
